<template>
  <div class="transactionDetails">
    <gl-transaction :tx="tx">
      <template #header="{ id }">
        <p class="text-truncate">
          {{ id }}
        </p>
      </template>
      <template #input="{ inputs }">
        <template v-if="inputs?.length">
          <div v-for="(input, index) in inputs" :key="index" class="text-truncate">
            <router-link :to="{ name: 'Address', params: { id: input.address } }" class="text-link">
              {{ input.name }}
            </router-link>
          </div>
        </template>
        <template v-else>
          Coinbase (newly generated coins)
        </template>
      </template>
      <template #output="{ outputs }">
        <table class="tableInCell">
          <tr v-for="(output, index) in outputs" :key="index" class="tableInCell__row">
            <td class="tableInCell__cell tableInCell__cell--title text-truncate">
              <router-link
                :to="{ name: 'Address', params: { id: output.address } }"
                class="text-link"
                :class="{ 'text-gray': output.locked || output.locktime > +new Date() }"
              >
                {{ output.name }}
              </router-link>
            </td>
            <td class="tableInCell__cell">
              <div
                class="tableInCell__value"
                :class="{ 'text-gray': output.locked || output.locktime > +new Date() }"
              >
                {{ output.value / 100000000 }} PLC
                <router-link
                  v-if="output.spentIn"
                  :to="{ name: 'Transaction', params: { id: output.spentIn } }"
                >
                  <gl-svg-icon name="arrow-narrow" class="transactionDetails__arrowIcon" />
                </router-link>
              </div>
            </td>
            <td
              v-if="output.locktime"
              class="tableInCell__cell"
              :class="output.locktime > +new Date() ? 'text-gray' : 'text-yellow'"
            >
              {{ unlockedDate(output.locktime) }}
            </td>
          </tr>
        </table>
      </template>
      <template v-if="tx.confirmations < 120" #confirmation="{ confirmations }">
        <gl-status v-if="confirmations" variant="info" size="sm"
          >{{ confirmations }} Confirmations
        </gl-status>
        <gl-status v-else variant="danger" size="sm">Unconfirmed transaction!</gl-status>
      </template>
    </gl-transaction>
  </div>
</template>

<script>
import GlStatus from '@gl/GlStatus'
import GlTransaction from '@gl/GlTransaction'
import GlSvgIcon from '@gl/GlSvgIcon'
import { format } from 'date-fns'
import { dateFormat } from '@/config'
// import { formatDuration, subMilliseconds, intervalToDuration } from 'date-fns'

export default {
  name: 'TransactionDetails',
  components: {
    GlStatus,
    GlTransaction,
    GlSvgIcon,
  },
  props: {
    tx: {
      type: Object,
      required: true,
    },
  },
  methods: {
    age(val) {
      if (typeof val !== 'number') return ''
      const minute = 60
      const hour = minute * 60
      const day = hour * 24

      const days = Math.floor(val / day)
      const hours = Math.floor((val - days * day) / hour)
      const minutes = Math.floor((val - days * day - hours * hour) / minute)

      return days
        ? `${days}d ${hours}h ${minutes}m`
        : hours
        ? `${hours}h ${minutes}m`
        : `${minutes}m`

      // return formatDuration(
      //   intervalToDuration({
      //     start: subMilliseconds(new Date(), val * 1000),
      //     end: new Date(),
      //   }),
      //   { format: ['years', 'months', 'days', 'hours', 'minutes'] }
      // )
    },
    unlockedDate(date) {
      return format(date, dateFormat)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/blocks/tableInCell';

.transactionDetails {
  border: $border;
  overflow: hidden;
  padding: 16px;

  &__arrowIcon {
    margin-left: 4px;
  }
}
</style>
